// INDEX
export const ROOT = '';
export const INDEX = '/';
export const QUIZ = '/quiz';
export const RESULT = '/result';
export const RESULT_DONE = '/result/done';
export const RESULT_NO_TRY = '/result/notry';
export const RESULT_NO_TIME = '/result/notime';
export const NOT_FOUND = '/404';

